import { Navigate } from "react-router-dom";
import { useAuthContext } from "../../context/auth";
import { Loader } from "../Loader";

const PrivateRoute = ({ children, allowedRoles, allowedIds = null }) => {
  const { session, rol, id, isLoading } = useAuthContext(); // Asegúrate de extraer 'id' del contexto

  if (isLoading || session === undefined) {
    return <Loader fullPage />;
  }

  const hasAllowedRole = allowedRoles.includes(rol);
  const hasAllowedId = allowedIds ? allowedIds.includes(id) : true; // Si allowedIds es null, ignora el chequeo de ID

  if (!session || !hasAllowedRole || !hasAllowedId) {
    return <Navigate to="/login" replace />; // O redirige a /admin si prefieres
  }

  return children;
};

export default PrivateRoute;
